import { Renderer } from "@unseenco/taxi";
import { isDEVMODE, viewStorage } from "../_globals";
import Accordions from "../modules/accordions";
import WknSwiper from "../modules/wkn-swiper";
import { accompanimentSwiperOptions } from "../modules/accompaniment-swiper-options";

export default class PageHome extends Renderer {
  initialLoad() {
    const onDOMContentLoaded = () => {
      document.removeEventListener("DOMContentLoaded", onDOMContentLoaded);
      this.onEnter();
    };

    document.addEventListener("DOMContentLoaded", onDOMContentLoaded);
  }

  onEnter() {
    this.DOM = {
      profilesOffers: viewStorage.current.querySelector(".ProfilesOffers"),
      accompanimentSwiper: viewStorage.current.querySelector(
        ".Accompaniment .swiper",
      ),
      relatedPostsSwiper: viewStorage.current.querySelector(
        ".RelatedPosts .swiper",
      ),
      offersSliderSwiper: viewStorage.current.querySelector(
        ".BlockOffersSlider .swiper",
      ),
      testimonials2026Swiper: viewStorage.current.querySelector(
        ".BlockTestimonials2026 .swiper",
      ),
      testimonials2026Navigation: viewStorage.current.querySelector(
        ".BlockTestimonials2026 .swiper-navigation",
      ),
      testimonials2026Cards: viewStorage.current.querySelectorAll(
        ".BlockTestimonials2026 .testimonial-card",
      ),
    };

    this.init();
  }

  init() {
    const {
      profilesOffers = null,
      accompanimentSwiper = null,
      relatedPostsSwiper = null,
      offersSliderSwiper = null,
      testimonials2026Swiper = null,
      testimonials2026Navigation = null,
      testimonials2026Cards = [],
    } = this.DOM;

    if (profilesOffers)
      this.profilesOffersAccordionsModule = new Accordions(profilesOffers);
    if (accompanimentSwiper)
      this.accompanimentSwiperModule = new WknSwiper(
        accompanimentSwiper,
        accompanimentSwiperOptions,
      );
    if (relatedPostsSwiper)
      this.relatedPostsSwiperModule = new WknSwiper(relatedPostsSwiper, {
        slidesPerView: "auto",
      });
    if (offersSliderSwiper)
      this.offersSliderSwiperModule = new WknSwiper(offersSliderSwiper, {
        slidesPerView: "auto",
        // Marine (maquette mobile 4093:2504) : cartes espacées de 12.
        // La base ne s'applique que sous 768 : les paliers 768/1024 gardent
        // les 16 existants — le desktop ne bouge pas.
        spaceBetween: 12,
        centerInsufficientSlides: true,
        breakpoints: {
          768: {
            spaceBetween: 16,
          },
          1024: {
            spaceBetween: 16,
          },
        },
      });
    if (testimonials2026Swiper)
      this.testimonials2026SwiperModule = new WknSwiper(testimonials2026Swiper, {
        slidesPerView: "auto",
        spaceBetween: 16,
        centerInsufficientSlides: true,
        rewind: true,
        autoplay: {
          delay: 4500,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        },
        navigation: testimonials2026Navigation
          ? {
              nextEl: testimonials2026Navigation.querySelector(".next"),
              prevEl: testimonials2026Navigation.querySelector(".prev"),
            }
          : false,
        breakpoints: {
          1024: {
            spaceBetween: 20,
          },
        },
      });

    if (testimonials2026Cards.length) this.setupTestimonials2026Cards();
  }

  setupTestimonials2026Cards() {
    this.testimonials2026Handlers = [];

    this.DOM.testimonials2026Cards.forEach((card) => {
      const content = card.querySelector(".js-testimonial-content");
      const toggle = card.querySelector(".js-testimonial-toggle");

      if (!content || !toggle) return;

      card.classList.remove("--has-overflow", "--expanded");
      toggle.setAttribute("aria-expanded", "false");
      toggle.textContent = "Voir plus";

      const hasOverflow = content.scrollHeight > content.clientHeight + 2;
      if (!hasOverflow) return;

      card.classList.add("--has-overflow");

      const onToggle = () => {
        const isExpanded = card.classList.toggle("--expanded");
        toggle.setAttribute("aria-expanded", isExpanded ? "true" : "false");
        toggle.textContent = isExpanded ? "Voir moins" : "Voir plus";
      };

      toggle.addEventListener("click", onToggle);
      this.testimonials2026Handlers.push({ toggle, onToggle });
    });
  }

  onLeaveCompleted() {
    this.profilesOffersAccordionsModule &&
      this.profilesOffersAccordionsModule.destroy();
    this.accompanimentSwiperModule && this.accompanimentSwiperModule.destroy();
    this.relatedPostsSwiperModule && this.relatedPostsSwiperModule.destroy();
    this.offersSliderSwiperModule && this.offersSliderSwiperModule.destroy();
    this.testimonials2026SwiperModule &&
      this.testimonials2026SwiperModule.destroy();

    if (this.testimonials2026Handlers?.length) {
      this.testimonials2026Handlers.forEach(({ toggle, onToggle }) => {
        toggle.removeEventListener("click", onToggle);
      });
      this.testimonials2026Handlers = [];
    }
  }
}
